import { CIcon } from '~/icons/types'

export const ciSemitrailers: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.41 5.18H.59a.492.492 0 0 0-.492.492V16.87c0 .272.22.492.493.492h1.017a1.886 1.886 0 0 0 3.717-.295c.07.98.886 1.753 1.88 1.753a1.89 1.89 0 0 0 1.88-1.753c.07.98.885 1.753 1.879 1.753.966 0 1.762-.73 1.87-1.664l1.96-1.204h7.2v.23h-.122a.492.492 0 1 0 0 .984H23.1a.492.492 0 1 0 0-.985h-.122v-.23h.431c.272 0 .492-.22.492-.492V5.672a.492.492 0 0 0-.492-.492ZM3.44 17.836a.9.9 0 1 1 .001-1.8.9.9 0 0 1 0 1.8Zm3.765 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm3.759 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm11.953-2.869h-8.26a.47.47 0 0 0-.257.075l-1.744 1.064a1.883 1.883 0 0 0-3.572.694 1.888 1.888 0 0 0-1.88-1.753c-.993 0-1.809.773-1.879 1.753a1.888 1.888 0 0 0-1.88-1.753 1.89 1.89 0 0 0-1.8 1.326h-.562V6.164h21.839v8.803h-.005Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'semitrailers',
  type: 'thin'
}
